<template>
  <Icon>
    <template #component>
      <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <rect
          x="939.24"
          y="486.12"
          width="87.4"
          height="48.32"
          fill="currentColor"
        />
        <path
          d="M851.13,400.23a117,117,0,1,1-117,116.95A117.09,117.09,0,0,1,851.13,400.23Zm0,185.59a68.64,68.64,0,1,0-68.63-68.64A68.72,68.72,0,0,0,851.13,585.82Z"
          transform="translate(0 -8.58)"
          fill="currentColor"
        />
        <path
          d="M553.62,612.29a117,117,0,1,1-117,117A117.09,117.09,0,0,1,553.62,612.29Zm0,185.59A68.63,68.63,0,1,0,485,729.25,68.7,68.7,0,0,0,553.62,797.88Z"
          transform="translate(0 -8.58)"
          fill="currentColor"
        />
        <rect
          x="627.02"
          y="615.51"
          width="174.81"
          height="48.32"
          transform="translate(-224.12 434.34) rotate(-30)"
          fill="currentColor"
        />
        <rect
          x="682.26"
          y="316.04"
          width="48.32"
          height="174.81"
          transform="matrix(0.5, -0.87, 0.87, 0.5, 3.81, 804.92)"
          fill="currentColor"
        />
        <path
          d="M547.39,199.57a117,117,0,1,1-116.95,117A117.09,117.09,0,0,1,547.39,199.57Zm0,185.6a68.64,68.64,0,1,0-68.63-68.64A68.72,68.72,0,0,0,547.39,385.17Z"
          transform="translate(0 -8.58)"
          fill="currentColor"
        />
        <path
          d="M243.41,777.64a117,117,0,1,1-117,117A117.09,117.09,0,0,1,243.41,777.64Zm0,185.59a68.64,68.64,0,1,0-68.63-68.63A68.71,68.71,0,0,0,243.41,963.23Z"
          transform="translate(0 -8.58)"
          fill="currentColor"
        />
        <rect
          x="299.09"
          y="792.14"
          width="174.81"
          height="48.32"
          transform="translate(-356.37 294.03) rotate(-30)"
          fill="currentColor"
        />
        <rect
          x="378.49"
          y="534.55"
          width="48.32"
          height="174.81"
          transform="translate(-337.3 651.1) rotate(-60)"
          fill="currentColor"
        />
        <path
          d="M245.24,406.8a117,117,0,1,1-117,117A117.09,117.09,0,0,1,245.24,406.8Zm0,185.59a68.63,68.63,0,1,0-68.64-68.63A68.71,68.71,0,0,0,245.24,592.39Z"
          transform="translate(0 -8.58)"
          fill="currentColor"
        />
        <rect
          x="307.2"
          y="393.22"
          width="174.81"
          height="48.32"
          transform="translate(-155.83 244.64) rotate(-30)"
          fill="currentColor"
        />
        <path
          d="M243.52,8.58a117,117,0,1,1-117,117A117.09,117.09,0,0,1,243.52,8.58Zm0,185.59a68.63,68.63,0,1,0-68.63-68.63A68.7,68.7,0,0,0,243.52,194.17Z"
          transform="translate(0 -8.58)"
          fill="currentColor"
        />
        <rect
          x="376.21"
          y="125.41"
          width="48.32"
          height="174.81"
          transform="translate(15.88 444.56) rotate(-60)"
          fill="currentColor"
        />
        <rect y="863.46" width="151.81" height="48.32" fill="currentColor" />
        <rect y="495.79" width="151.81" height="48.32" fill="currentColor" />
        <rect y="76.69" width="151.81" height="48.32" fill="currentColor" />
        <rect
          x="158.43"
          y="580.76"
          width="470.3"
          height="48.32"
          transform="translate(-327.67 621.65) rotate(-58.96)"
          fill="currentColor"
        />
      </svg>
    </template>
  </Icon>
</template>
<script lang="ts">
interface size {
  height: number;
  width: number;
}
import { defineComponent } from "vue";
import Icon from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    Icon,
  },
});
</script>
<style scoped>
.custom-icons-list :deep(.anticon) {
  margin-right: 6px;
}
</style>
